export default __webpack_public_path__ + "static/media/bruce_team_member.41719be4.png";